import { render, staticRenderFns } from "./MedHxTab.vue?vue&type=template&id=b07e7438&scoped=true"
import script from "./MedHxTab.vue?vue&type=script&lang=js"
export * from "./MedHxTab.vue?vue&type=script&lang=js"
import style0 from "./MedHxTab.vue?vue&type=style&index=0&id=b07e7438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e7438",
  null
  
)

export default component.exports